export const PART_2_VIDEO_BANK = "part-2-video-bank";
export const INTERVIEW_BANK = "interview-bank";
export const VISUAL_ADMIN_QUESTION_BANKS = [
  "part-2-question-bank",
  "part-1-question-bank",
  "duke-elder-question-bank",
];

export const isPart2VideoBank = (bank) => bank === PART_2_VIDEO_BANK;

export const isInterviewBank = (bank) => bank === INTERVIEW_BANK;

export const isVisualAdminQuestionBank = (bank) =>
  VISUAL_ADMIN_QUESTION_BANKS.includes(bank);

export const getVideoStationVisualEditorUrl = (id) =>
  `/admin/${PART_2_VIDEO_BANK}/content/visual-edit/${encodeURIComponent(id)}`;

export const getVideoStationLegacyEditorUrl = (id) =>
  `/admin/${PART_2_VIDEO_BANK}/content/edit/${encodeURIComponent(id)}`;

export const getInterviewStationVisualEditorUrl = (id) =>
  `/admin/${INTERVIEW_BANK}/content/visual-edit/${encodeURIComponent(id)}`;

export const getInterviewStationLegacyEditorUrl = (id) =>
  `/admin/${INTERVIEW_BANK}/content/edit/${encodeURIComponent(id)}`;

export const getQuestionVisualEditorUrl = (bank, id) =>
  `/admin/${encodeURIComponent(bank)}/content/visual-edit/${encodeURIComponent(
    id,
  )}`;

export const getLegacyAdminContentEditUrl = (bank, id) =>
  `/admin/${encodeURIComponent(bank)}/content/edit/${encodeURIComponent(id)}`;

export const getAdminContentEditUrl = (
  bank,
  id,
  {
    visualForVideoBank = true,
    visualForQuestionBanks = true,
    visualForInterviewBank = true,
  } = {},
) => {
  if (isPart2VideoBank(bank) && visualForVideoBank) {
    return getVideoStationVisualEditorUrl(id);
  }

  if (isInterviewBank(bank) && visualForInterviewBank) {
    return getInterviewStationVisualEditorUrl(id);
  }

  if (isVisualAdminQuestionBank(bank) && visualForQuestionBanks) {
    return getQuestionVisualEditorUrl(bank, id);
  }

  return getLegacyAdminContentEditUrl(bank, id);
};

export const getStationViewPath = (bank, id) => {
  const encodedBank = encodeURIComponent(bank);
  const encodedId = encodeURIComponent(id);
  return bank === INTERVIEW_BANK || bank === PART_2_VIDEO_BANK
    ? `/stations/${encodedBank}/${encodedId}`
    : `/questions/${encodedBank}/${encodedId}`;
};

export const getStationViewUrl = (bank, id, { draft = false } = {}) => {
  const path = getStationViewPath(bank, id);
  return draft ? `${path}?forceDraft=true` : path;
};
